import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SECURE_ROUTES } from './secure.route';
import { AppAuthGuard } from '../modules/shared/services/auth-guard/auth-guard.service';
import { EmployeeProfileComponent } from '../components/employee-profile/employee-profile.component';

const routes: Routes = [
  {
    path: '',
    children: SECURE_ROUTES,
    canActivate: [AppAuthGuard],
    data: {roles: ['ROLE_BK', 'ROLE_EMP']}
  },
  {
    path: 'employeeprofile',
    component: EmployeeProfileComponent,
    canActivate: [AppAuthGuard],
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
